import type { InventoryTracking } from "../../types/terminalFlow";

/**
 * What the kiosk's URL says the fridge tracks, until the backend reports it: `?flow=nonRfid` is a
 * fridge without readers. Read in every build, production included, because the configured URL of a
 * kiosk is what turns it on (decided in !272). Null when the URL says nothing. A module of its own:
 * tests mock localStorage.ts partially.
 */
export const readInventoryTrackingFromUrl = (): InventoryTracking | null =>
	new URLSearchParams(window.location.search).get("flow") === "nonRfid" ? "NONE" : null;
